<template>
  <!--
  <div :class="$style.emergency_contact">
    <div :class="$style.title">ホームランカードページ追加のお知らせ</div>
    <div :class="$style.news_area">
      <p>ホームランカードページは<router-link to=/hrcard>こちら</router-link>からご覧いただけます。<br></p>
    </div>
  </div>-->
  <div :class="$style.emergency_contact">
    <!--<div :class="$style.title">館内の上映動画の案内ページ追加のお知らせ</div>
    <div :class="$style.news_area">
      <p>館内の上映動画の紹介は<router-link to=/movie>こちら</router-link>からご覧いただけます。<br></p>
    </div>
    <br /><br />-->
    <!-- <div :class="$style.title">展示場のご案内ページ追加のお知らせ</div>
    <div :class="$style.news_area">
      <p>展示場の紹介は<router-link to=/exhibit>こちら</router-link>からご覧いただけます。<br></p>
    </div> -->
    <!-- <div :class="$style.title">松井秀喜の言葉リニューアルのお知らせ</div>
    <div :class="$style.news_area">
      <p>松井秀喜の言葉は<router-link to=/saying>こちら</router-link>からご覧いただけます。<br></p>
    </div> -->
    <ul :class="$style.tab" >
      <li 
        :class="[$style.title, activeTab === 'news' ? $style.active : '']"
        @click="activeTab = 'news'"
      >
      お知らせ
      </li>
      <li 
        :class="[$style.title, activeTab === 'contents' ? $style.active : '']"
        @click="activeTab = 'contents'"
      >
      注目コンテンツ
      </li>
    </ul>
    <div v-if="activeTab === 'news'" :class="$style.news_area">
      <p>停止しておりました, LookMe, 夢郵便, お客様の声の更新を再開いたしました。<br>
         長らくご不便をおかけいたしましたことを、深くお詫び申し上げます。<br>
      </p>
    </div>
    <div v-if="activeTab === 'contents'" :class="$style.news_area">
      <p>松井秀喜の言葉（<router-link to=/saying>こちら</router-link>からご覧いただけます）<br></p>
      <p>この日この時（<router-link to=/history>こちら</router-link>からご覧いただけます）<br></p>
    </div>
    
    <!--
    <div :class="$style.title">HP修理中のお知らせ</div>
    <div :class="$style.news_area">
      <p>一部メンテナンスのため閲覧できず、ご迷惑をおかけします。</p>
    </div>
    -->
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "Contact",
  data(){
    return{
      activeTab: "news",
    };
  },
  props: {
    input_date: {
      type: Object,
    },
  },
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  $background-color: #403f3f;

  .emergency_contact {
    height: 130px;
    width: 300px;
    background: rgba(#403f3f, 0.9);
    padding: 0px 10px;
    color: #fffafa;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    z-index: 2;
    .tab {
      display: flex;
      width: 100%;
      margin-bottom: 0px;
      padding-left: 0px;
    }
    .title {
      background: transparent;
      margin-top: 3px;
      font-size: 13px;
      text-align: center;
      border-bottom: 1px solid #fff;
      padding-bottom: 5px;
      flex: 1;
      list-style: none;
    }
    .title:hover{
      background: rgba(lighten($background-color, 20%), 0.5);
      cursor: pointer;
    }
    .active{
      border-bottom: 4px solid #fff;
      font-weight: bold;
    }
    .news_area {
      //height: 20px;
      margin-top: 10px;
      font-size: 11px;
    }
  }
}

@media only screen and (min-width: 1024px) {
  $background-color: #403f3f;

  .emergency_contact {
    width: 600px;
    background: rgba(#403f3f, 0.7);
    color: #fff;
    //padding: 10px;
    //padding-top: 0px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    .tab {
      display: flex;
      width: 100%;
      margin-bottom: 0px;
      padding-left: 0px;
    }
    .title {
      background: transparent;
      font-size: 18px;
      text-align: center;
      border-bottom: 1px solid #fff;
      padding-bottom: 5px;
      padding: 10px;
      flex: 1;
      list-style: none;
    }
    .title:hover{
      background: rgba(lighten($background-color, 20%), 0.5);
      cursor: pointer;
    }
    .active{
      border-bottom: 5px solid #fff;
      font-weight: bold;
    }
    .news_area {
      margin: 0px 20px;
      margin-top: 10px;
      min-height: 80px;
      p {
        font-size: 15px;
      }
    }
  }
}
</style>
